import axios from 'axios'
import { getApiServer } from '@/config/api'
import { getStoredToken } from '@/auth/session'

const instance = axios.create({
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json'
  }
})

instance.interceptors.request.use((config) => {
  const token =
    getStoredToken() ||
    (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('user_token')) ||
    ''
  if (token) {
    config.headers = config.headers || {}
    config.headers.UserToken = token
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
})

instance.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err && err.response && err.response.status
    const body = err && err.response && err.response.data
    console.warn('[P1_VP12 http]', status, err && err.config && err.config.url, body || (err && err.message))
    return Promise.reject(err)
  }
)

export default instance

export function apiUrl (path) {
  const base = (getApiServer() || '/bestbuytest').replace(/\/$/, '')
  const p = String(path || '').replace(/^\//, '')
  return `${base}/${p}`
}
